
<script>
import http from '@/service/http'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Logs',
  data () {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    }
  },
  mounted () {
    this.paginate()
  },
  methods: {
    async paginate (page) {
      if (page) {
        this.pagination.current_page = page
      }
      const { data } = await http.get(`/usuarios-log?page=${this.pagination.current_page}&busca=${this.busca}`)
      if (data != null) {
        this.list = data.data
        this.pagination.current_page = data.current_page
        this.pagination.last_page = data.last_page
      }
    },
    async buscar ($page) {
      const { data } = await http.get(`/usuarios-log?&busca=${this.busca}`)
      if (data != null) {
        this.list = data.data
        this.pagination.current_page = data.current_page
        this.pagination.last_page = data.last_page
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters(['permissoes']),
    hasItens () {
      return this.list.length > 0
    }
  }
}
</script>

<template>
	<div>

    <div class="content">

      <div class="row">
        <div class="col s12 m8">
          <h5>Usuários :: Logs</h5>
        </div>
        <div class="input-field col s9 m4">
          <form @submit.prevent="buscar">
            <input id="busca" type="text" v-model="busca">
            <label for="busca">Buscar</label>
          </form>        
        </div>
      </div>

      <div class="center-align" v-show="!hasItens && !loading">
        <p>Nenhum registro encontrado!</p>
      </div>

      <div class="row z-depth-1" v-show="hasItens">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
              <tr>
                <th>Data Acesso</th>
                <th>Usuário</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="log in list">
                <td>{{ formatDate(log.created_at) }}</td>
                <td>{{ log.nome_completo }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-show="hasItens">
        <div class="col s12 center-align">
          <paginate
          :page-count='pagination.last_page'
          :click-handler="paginate"
          :prev-text="'chevron_left'"
          :next-text="'chevron_right'"
          :container-class="'pagination'"
          :page-class="'waves-effect'"
          :prev-class="'material-icons'"
          :next-class="'material-icons'"
          :force-page='pagination.current_page-1'
          >
        </paginate>
      </div>
    </div>

  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/features/usuarios/logs/index.vue